/**
 * feature flags namespace "enterprise-ui_"
 */
export const Features = {
  'enterprise-ui_fedRateBanner': 'enterprise-ui_fedRateBanner',
  'enterprise-ui_enableQuarterEndReminder': 'enterprise-ui_enableQuarterEndReminder',
  'enterprise-ui_enableFinanceIQ': 'enterprise-ui_enableFinanceIQ',
  'enterprise-ui_enablePricingForAccounts': 'enterprise-ui_enablePricingForAccounts',
  'enterprise-ui_enableLendingConnectionsIntegration': 'enterprise-ui_enableLendingConnectionsIntegration',
  'enterprise-ui_enableLendingWidget': 'enterprise-ui_enableLendingWidget',
  'enterprise-ui_enableHomepageForAccounts': 'enterprise-ui_enableHomepageForAccounts',
  'enterprise-ui_enableHomepageForEntAccounts': 'enterprise-ui_enableHomepageForEntAccounts',
  'enterprise-ui_enableNewDivisionAlert': 'enterprise-ui_enableNewDivisionAlert',
  'enterprise-ui_enableAcquisitionOffer': 'enterprise-ui_enableAcquisitionOffer',
  'enterprise-ui_enablePrivacyPolicyBanner': 'enterprise-ui_enablePrivacyPolicyBanner',
  'enterprise-ui_useMarketingArtifacts': 'enterprise-ui_useMarketingArtifacts',
  'enterprise-ui_enableFundbox': 'enterprise-ui_enableFundbox',
  'enterprise-ui_enableInstantPay': 'enterprise-ui_enableInstantPay',
  'enterprise-ui_enableInstantPayForUsers': 'enterprise-ui_enableInstantPayForUsers',
  'enterprise-ui_enableFinanceIQHomepageWidget': 'enterprise-ui_enableFinanceIQHomepageWidget',
  'enterprise-ui_invoiceApiMigration': 'enterprise-ui_invoiceApiMigration',
  'enterprise-ui_enableOffNetworkFinance': 'enterprise-ui_enableOffNetworkFinance',
  'enterprise-ui_enableKpiSpotlightBanner': 'enterprise-ui_enableKpiSpotlightBanner',
  'enterprise-ui_enableSeaPendingClearCsv': 'enterprise-ui_enableSeaPendingClearCsv',
  'enterprise-ui_enableMarketingWidgetCarousel': 'enterprise-ui_enableMarketingWidgetCarousel',
} as const;

/**
 * treatment definitions by env
 * utilized for determining how to serve treatment if split fails to load
 */
const features =
  import.meta.env.VITE_ENV === 'prod'
    ? {
        [Features['enterprise-ui_fedRateBanner']]: 'off',
        [Features['enterprise-ui_enableQuarterEndReminder']]: 'off',
        [Features['enterprise-ui_enableFinanceIQ']]: 'off',
        [Features['enterprise-ui_enablePricingForAccounts']]: 'off',
        [Features['enterprise-ui_enableLendingConnectionsIntegration']]: 'off',
        [Features['enterprise-ui_enableLendingWidget']]: 'off',
        [Features['enterprise-ui_enableHomepageForAccounts']]: 'off',
        [Features['enterprise-ui_enableHomepageForEntAccounts']]: 'off',
        [Features['enterprise-ui_enableNewDivisionAlert']]: 'off',
        [Features['enterprise-ui_enableAcquisitionOffer']]: 'off',
        [Features['enterprise-ui_enablePrivacyPolicyBanner']]: 'off',
        [Features['enterprise-ui_useMarketingArtifacts']]: 'off',
        [Features['enterprise-ui_enableFundbox']]: 'off',
        [Features['enterprise-ui_enableInstantPay']]: 'off',
        [Features['enterprise-ui_enableInstantPayForUsers']]: 'off',
        [Features['enterprise-ui_enableFinanceIQHomepageWidget']]: 'off',
        [Features['enterprise-ui_invoiceApiMigration']]: 'off',
        [Features['enterprise-ui_enableOffNetworkFinance']]: 'off',
        [Features['enterprise-ui_enableKpiSpotlightBanner']]: 'off',
        [Features['enterprise-ui_enableSeaPendingClearCsv']]: 'off',
        [Features['enterprise-ui_enableMarketingWidgetCarousel']]: 'off',
      }
    : {
        [Features['enterprise-ui_fedRateBanner']]: 'off',
        [Features['enterprise-ui_enableQuarterEndReminder']]: 'off',
        [Features['enterprise-ui_enableFinanceIQ']]: 'on',
        [Features['enterprise-ui_enablePricingForAccounts']]: 'on',
        [Features['enterprise-ui_enableLendingConnectionsIntegration']]: 'on',
        [Features['enterprise-ui_enableLendingWidget']]: 'on',
        [Features['enterprise-ui_enableHomepageForAccounts']]: 'on',
        [Features['enterprise-ui_enableHomepageForEntAccounts']]: 'on',
        [Features['enterprise-ui_enableNewDivisionAlert']]: 'on',
        [Features['enterprise-ui_enableAcquisitionOffer']]: 'on',
        [Features['enterprise-ui_enablePrivacyPolicyBanner']]: 'on',
        [Features['enterprise-ui_useMarketingArtifacts']]: 'on',
        [Features['enterprise-ui_enableFundbox']]: 'on',
        [Features['enterprise-ui_enableInstantPay']]: 'on',
        [Features['enterprise-ui_enableInstantPayForUsers']]: 'on',
        [Features['enterprise-ui_enableFinanceIQHomepageWidget']]: 'on',
        [Features['enterprise-ui_invoiceApiMigration']]: 'on',
        [Features['enterprise-ui_enableOffNetworkFinance']]: '0.0',
        [Features['enterprise-ui_enableKpiSpotlightBanner']]: 'on',
        [Features['enterprise-ui_enableSeaPendingClearCsv']]: 'on',
        [Features['enterprise-ui_enableMarketingWidgetCarousel']]: 'on',
      };

export default features;
